let webUserInfo = {
    clientInfo: {},
    sysInfo: {},
    userInfo: {},
    generalSettings: {},
    user_role: {}
  };
  
  // Function to set user info and store it in localStorage
  export const setWebUserInfo = (data) => {
    webUserInfo = { ...data };
    localStorage.setItem('webUserInfo', JSON.stringify(webUserInfo));
  };
  
  // Function to get user info from localStorage
  export const getWebUserInfo = () => {
    const storedData = localStorage.getItem('webUserInfo');
    if (storedData) {
      webUserInfo = JSON.parse(storedData);
    }
    return webUserInfo;
  };
  
  // Call this function on page load to restore data
  export const initializeWebUserInfo = () => {
    const storedData = localStorage.getItem('webUserInfo');
    if (storedData) {
      webUserInfo = JSON.parse(storedData);
    }
  };
  
  